'use client';

import * as DS from '@aurorasolar/ds';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';

const StyledButton = styled(DS.Button)`
  height: 32px;
  width: 32px;
  padding: 6px;
`;

export default function SocialShare() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [url, setUrl] = useState('');

  useEffect(() => {
    const origin = window.location.origin;
    const qs = searchParams.toString();
    setUrl(`${origin}${pathname}${qs ? `?${qs}` : ''}`);
  }, [pathname, searchParams]);

  return (
    <DS.Flex alignItems="center" flexDirection="row" flexShrink={1} justifyContent={{ _: 'start', md: 'end' }}>
      <DS.Text>Share</DS.Text>
      <StyledButton onClick={() => shareSocialMedia('facebook', url)}>
        <svg
          className="icon icon-tabler icons-tabler-filled icon-tabler-brand-facebook"
          fill="currentColor"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0h24v24H0z" fill="none" stroke="none" />
          <path d="M18 2a1 1 0 0 1 .993 .883l.007 .117v4a1 1 0 0 1 -.883 .993l-.117 .007h-3v1h3a1 1 0 0 1 .991 1.131l-.02 .112l-1 4a1 1 0 0 1 -.858 .75l-.113 .007h-2v6a1 1 0 0 1 -.883 .993l-.117 .007h-4a1 1 0 0 1 -.993 -.883l-.007 -.117v-6h-2a1 1 0 0 1 -.993 -.883l-.007 -.117v-4a1 1 0 0 1 .883 -.993l.117 -.007h2v-1a6 6 0 0 1 5.775 -5.996l.225 -.004h3z" />
        </svg>
      </StyledButton>
      <StyledButton onClick={() => shareSocialMedia('twitter', url)}>
        <svg
          className="icon icon-tabler icons-tabler-filled icon-tabler-brand-x"
          fill="currentColor"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0h24v24H0z" fill="none" stroke="none" />
          <path d="M8.267 3a1 1 0 0 1 .73 .317l.076 .092l4.274 5.828l5.946 -5.944a1 1 0 0 1 1.497 1.32l-.083 .094l-6.163 6.162l6.262 8.54a1 1 0 0 1 -.697 1.585l-.109 .006h-4.267a1 1 0 0 1 -.73 -.317l-.076 -.092l-4.276 -5.829l-5.944 5.945a1 1 0 0 1 -1.497 -1.32l.083 -.094l6.161 -6.163l-6.26 -8.539a1 1 0 0 1 .697 -1.585l.109 -.006h4.267z" />
        </svg>
      </StyledButton>
      <StyledButton onClick={() => shareSocialMedia('linkedin', url)}>
        <svg
          className="icon icon-tabler icons-tabler-filled icon-tabler-brand-linkedin"
          fill="currentColor"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0h24v24H0z" fill="none" stroke="none" />
          <path d="M17 2a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5h-10a5 5 0 0 1 -5 -5v-10a5 5 0 0 1 5 -5zm-9 8a1 1 0 0 0 -1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0 -1 -1m6 0a3 3 0 0 0 -1.168 .236l-.125 .057a1 1 0 0 0 -1.707 .707v5a1 1 0 0 0 2 0v-3a1 1 0 0 1 2 0v3a1 1 0 0 0 2 0v-3a3 3 0 0 0 -3 -3m-6 -3a1 1 0 0 0 -.993 .883l-.007 .127a1 1 0 0 0 1.993 .117l.007 -.127a1 1 0 0 0 -1 -1" />
        </svg>
      </StyledButton>
    </DS.Flex>
  );
}

const shareSocialMedia = (media: string, returnUrl: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  let windowUrl: string;
  switch (media) {
    case 'facebook':
      windowUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(returnUrl)}`;
      break;
    case 'twitter':
      windowUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(returnUrl)}&text=Check%20this%20out!`;
      break;
    case 'linkedin':
      windowUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(returnUrl)}`;
      break;
    default:
      return;
  }

  window.open(windowUrl, `${media}-share-dialog`, 'width=800,height=600');
};
